import ThemeProvider from 'src/theme';
import { SnackbarProvider } from 'src/components/snackbar';
import NewVersionPrompt from 'src/components/new-version-prompt';
import { AuthProvider } from 'src/auth/context';
import Router from 'src/routes';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <SnackbarProvider>
          <Router />
          <NewVersionPrompt />
        </SnackbarProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}
